<template>
  <div id="app">
    <Header title="Cash" :hideUserDropdown="!user" id="header" />
    <Loading v-if="validatingToken" />
    <Content v-else />
    <Footer />
    <LGPDModal />
    <LGPDSuporteModal v-if="user && user.tipoUsuario >= 1" />
  </div>
</template>

<script>
import axios from "axios";
import { userKey } from "@/global";
import { decodeToken } from "@/config/globalFacilities";
import { baseApiUrl, baseFrotendAuth, baseAuthApiUrl } from "@/env";
import { mapState } from "vuex";
import Header from "@/components/template/Header";
import Content from "@/components/template/Content";
import Footer from "@/components/template/Footer";
import Loading from "@/components/template/Loading";
import LGPDModal from "./components/msgs/LGPDModal.vue";
import LGPDSuporteModal from "./components/msgs/LGPDSuporteModal.vue";

export default {
  name: "App",
  components: { Header, Content, Footer, Loading, LGPDModal, LGPDSuporteModal },
  data: function () {
    return {
      validatingToken: true,
      isValidating: false, // Flag para evitar múltiplas execuções
      userSetInStore: false, // Flag para evitar múltiplos setUser
      userParams: {},
      baseApiUrl: baseApiUrl,
    };
  },
  methods: {
    async signin() {
      const query = this.$route.query;

      const json = localStorage.getItem(userKey);
      if (!json && !query.signin) {
        window.location.href = baseFrotendAuth;
        return;
      }
      if (query.signin) {
        let userToken = query.signin;
        let token = userToken.split("signin")[0];
        const userAuth = decodeToken(token);
        const userData = { ...userAuth, token };
        userData.name = userData.name.split(" ")[0];
        this.$store.commit("setUser", userData);
        localStorage.setItem(userKey, JSON.stringify(userData));
        this.$router.push({ path: "/" });
      }
      return true;
    },
    async validateToken() {
      // Evita múltiplas chamadas simultâneas
      if (this.isValidating) {
        return;
      }
      
      this.isValidating = true;
      this.validatingToken = true;

      await this.signin();

      const json = localStorage.getItem(userKey);
      
      if (!json) {
        this.isValidating = false;
        window.location.href = baseFrotendAuth;
        return;
      }
      
      const userData = JSON.parse(json);

      // Declarar rotas alternativas criadas em router.js
      // As rotas alternativas dispensam validação de usuário
      const alternates = [
        // "auth",
        "apresentacao",
        "validator",
        "request-password-reset",
        "password-reset",
      ];

      // rota primária
      if (!userData && this.$route.name === "user-unlock") {
        const res = await axios.get(
          `${baseApiUrl}/${this.$route.name}/${this.$route.params.id}/${this.$route.params.token}`
        );

        this.$toasted.global.defaultSuccess({ msg: res.data });
        this.isValidating = false;
        window.location.href = baseFrotendAuth;
        return;
      }

      if (!userData && alternates.indexOf(this.$route.name) < 0) {
        this.$cookies.set("noUserRoute", this.$route.fullPath);
        this.isValidating = false;
        this.validatingToken = false;
        window.location.href = baseFrotendAuth;
        return;
      }
      
      // Se a rota é alternativa, não precisa validar token
      if (alternates.indexOf(this.$route.name) >= 0) {
        this.isValidating = false;
        this.validatingToken = false;
        return;
      }

      // Valida o token apenas se userData existe E rota não é alternativa
      try {
        const res = await axios.post(
          `${baseAuthApiUrl}/validateToken`,
          userData
        );
        
        if (baseApiUrl.indexOf("localhost") >= 0 || (userData && userData.admin >= 1)) {
          console.log(userData);
        }
        
        if (res.data) {
          // Só seta o user no store se ainda não foi setado
          if (!this.userSetInStore) {
            this.$store.commit("setUser", userData);
            this.userSetInStore = true;
          }
          
          this.userParams = userData;
        }
        else {
          localStorage.removeItem(userKey);
          if (alternates.indexOf(this.$route.name) < 0) {
            this.isValidating = false;
            window.location.href = baseFrotendAuth;
            return;
          }
        }
      } catch (error) {
        localStorage.removeItem(userKey);
        this.isValidating = false;
        window.location.href = baseFrotendAuth;
        return;
      }

      // Adiciona o script apenas se userData.tipoUsuario >= 1
      if (userData.tipoUsuario >= 1) {
        (function (d, t) {
          var BASE_URL = "https://bot.azulbot.com.br";
          var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
          g.src = BASE_URL + "/packs/js/sdk.js";
          g.defer = true;
          g.async = true;
          s.parentNode.insertBefore(g, s);
          g.onload = function () {
            window.chatwootSDK.run({
              websiteToken: "Ej3T8otrK83xBq2D2LfvmFan",
              baseUrl: BASE_URL,
            });
          };
        })(document, "script");
      }

      this.isValidating = false;
      this.validatingToken = false;
    },
  },
  created() {
    this.validateToken();
    this.$cookies.set("uLast", this.$route.fullPath);
  },
  computed: mapState(["user"]),
};
</script>

<style>
* {
  font-family: "Lato", sans-serif;
}

body {
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100vh;
  display: grid;
  grid-template-rows: 60px 1fr 40px;
  grid-template-columns: 300px 1fr;
  grid-template-areas:
    "header header"
    "content content"
    "footer footer";
}
</style>
